import './formatted-text.scss';

type FormattedTextProps = {
  html: string;
  className?: string;
};

export function FormattedText({ html, className = '' }: FormattedTextProps) {
  return <div className={`formatted-text ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
